import Vue from "vue";

Vue.prototype.$utils = {
    getTimeStr(timestamp) {
        var strDate = '';
        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
        strDate = Y + M + D + h + m + s;
        return strDate;
    },
    getNetSpaceStr(space) {
        var netSpace = 0
        if (space) {
            netSpace = parseFloat(space)
        }
        if (netSpace > Math.pow(1024, 6)) {
            return (netSpace / Math.pow(1024, 6)).toFixed(2) + "EiB"
        } else if (netSpace > Math.pow(1024, 5)) {
            return (netSpace / Math.pow(1024, 5)).toFixed(2) + "PiB"
        } else if (netSpace > Math.pow(1024, 4)) {
            return (netSpace / Math.pow(1024, 4)).toFixed(2) + "TiB"
        } else if (netSpace > Math.pow(1024, 3) * 11) {
            return (netSpace / Math.pow(1024, 4)).toFixed(2) + "TiB"
        } else {
            return (netSpace / Math.pow(1024, 4)).toFixed(4) + "TiB"
        }
    },
    getRewardPercentage(claimable) {
        return (claimable / Math.pow(10, 12) / 1.75 * 100).toFixed(4)
    },
    getReward(claimable) {
        return (claimable / Math.pow(10, 12)).toFixed(4)
    },
    getNumDecimal(value, fix) {
        if (value) {
            value = new Number(value)
        } else {
            value = 0
        }
        if (value == 0) {
            return 0
        } else {
            return value.toFixed(fix)
        }
    },
    timeFormat(str) {   //用于后锻返回日期型时间格式
        try {
            const date_ = new Date(str)
            console.log(date_)
            const o = {
                'M':  date_.getMonth()+1,
                'Y': date_.getFullYear(),
                'D': date_.getDate(),
                'h': date_.getHours(),
                'm': date_.getMinutes(),
                's': date_.getSeconds()
            } 
            return `${o.Y}-${o.M}-${o.D} ${o.h}:${o.m}:${o.s}`
        } catch (err) {
            console.error(err)
        }
    }
}